import { z } from 'zod';

export const siteFormValidationSchema = z.object({
  id: z.string().nullable().optional(),

  // Basic Info
  name: z.string().min(1, 'Site name is required'),
  organization: z.string().min(1, 'Organization is required'),

  // Location
  address: z.string().min(1, 'Address is required'),
  city: z.string().nullable().optional(),
  state: z.string().nullable().optional(),
  zip: z.string().nullable().optional(),
  country: z.string().nullable().optional(),
  phone_number: z.string().nullable().optional(),

  latitude: z
    .string()
    .regex(/^-?\d+(\.\d+)?$/, 'Latitude must be a valid number')
    .min(1, 'Latitude is required'),

  longitude: z
    .string()
    .regex(/^-?\d+(\.\d+)?$/, 'Longitude must be a valid number')
    .min(1, 'Longitude is required'),

  elevation: z
    .string()
    .regex(/^\d+(\.\d+)?$/, 'Elevation must be a number')
    .nullable()
    .optional(),

  // Address line 2
  address_2: z.string().optional(),

  // Licensing
  licensed: z.boolean().optional(),

  // Features
  drill_enabled: z.boolean().optional(),
  show_safe_unsafe: z.boolean().optional(),

  // Pre-selected Provider Orgs
  preselected_provider_ids: z.array(z.string()).optional(),
});
